/* eslint-disable react/prop-types */
import React from 'react';
import { uk } from 'date-fns/locale';
import { format, parseISO } from 'date-fns';
// mui
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const InputDate = ({
  name,
  error,
  label,
  value,
  maxDate,
  minDate,
  touched,
  required,
  handleBlur,
  handleChange,
}) => (
  <div className='form-outline mb-4 DashBoardInputBx'>
    <label id={name} className='form-label' htmlFor={name}>
      {label}
      {required && <span className='RedStar'>*</span>}
    </label>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={uk}>
      <DatePicker
        maxDate={parseISO(maxDate)}
        minDate={parseISO(minDate)}
        value={value ? parseISO(value) : null}
        onClose={() => handleBlur({ target: { name } })}
        onChange={newValue => handleChange({ target: { name, value: newValue ? format(newValue, 'yyyy-MM-dd') : '' } })}
        sx={{
          width: '100%',
          height: '66px',
          outline: 'none',
          borderRadius: '6px',
          border: touched && error ? '1px dashed red' : '1px dashed #a7a6a6',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            outline: 'none',
          },
          '& .MuiInputBase-input': {
            p: '20px',
            border: 'none',
            outline: 'none',
          },
        }}
      />
    </LocalizationProvider>
    {
      touched && error && (
        <div className='text-danger'>{error}</div>
      )
    }
  </div>
);

export default InputDate;
